import PaymentsIcon from '../../../assets/icons/paymentIcon.svg?react';
import HomeIcon from '../../../assets/icons/honeIcon.svg?react';
import MapIcon from '../../../assets/icons/mapIcon.svg?react';
import ProfileIcon from '../../../assets/icons/profileIcon.svg?react';
import { ROUTES } from '../../../constants/routes';

export const bottomNavigation = [
  {
    to: `/${ROUTES.CABINET}`,
    value: `/${ROUTES.CABINET}`,
    icon: <HomeIcon width={24} height={24} />,
  },
  {
    to: ROUTES.CAB_TRANSACTIONS,
    value: `/${ROUTES.CABINET}/${ROUTES.CAB_TRANSACTIONS}`,
    icon: <PaymentsIcon width={24} height={24} />,
  },
  {
    to: ROUTES.MAP,
    value: `/${ROUTES.CABINET}/${ROUTES.MAP}`,
    icon: <MapIcon width={24} height={24} />,
  },
  {
    to: ROUTES.CAB_PROFILE,
    value: `/${ROUTES.CABINET}/${ROUTES.CAB_PROFILE}`,
    icon: <ProfileIcon width={24} height={24} />,
  },
];
